import {TvShopEntertainmentPackGroup} from '../interfaces/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.interface';
import {TvShopEntertainmentPack} from '../model/tv-shop-entertainment-pack';
import {OmapiIdsUtils} from '../shared/utils/omapi-ids/omapi-ids-utils';

export class TvShopEntertainmentPackGroupFactory {
  public static build(entertainmentPackGroups: TvShopEntertainmentPackGroup[], entertainmentPacks: TvShopEntertainmentPack[]): TvShopEntertainmentPack[] {
    return entertainmentPackGroups.map((entertainmentPackGroup) => {
      const tvShopEntertainmentPack = new TvShopEntertainmentPack();
      tvShopEntertainmentPack.omapiId = entertainmentPackGroup.omapiId;
      tvShopEntertainmentPack.isGroupPack = true;
      tvShopEntertainmentPack.subscribed = entertainmentPackGroup.childPackOmapiIds.some((entertainmentPackOmapiId) => {
        return entertainmentPacks.some((entertainmentPack) => {
          return (entertainmentPack.omapiId === entertainmentPackOmapiId && entertainmentPack.subscribed);
        });
      });
      tvShopEntertainmentPack.priceDetail = entertainmentPacks.find((entertainmentPack) => {
        return entertainmentPack.omapiId === entertainmentPackGroup.defaultChildPackOmapiId;
      }).priceDetail;
      tvShopEntertainmentPack.childPacks = entertainmentPackGroup.childPackOmapiIds.map((omapiId) => {
        return entertainmentPacks.find((entertainmentPack) => {
          return entertainmentPack.omapiId === omapiId;
        });
      });
      tvShopEntertainmentPack.showSubtitleInCarousel = entertainmentPackGroup.omapiId !== OmapiIdsUtils.DISNEY_PLUS_ID;
      return tvShopEntertainmentPack;
    });
  }
}
